import convertColor from 'color-convert';
import { Theme } from '@routific/hive';
import { colorVars } from '@routific/hive/v5';

/** Hex fallback for rgba() helpers that cannot consume CSS variables. */
const defaultBaseColor = Theme.Colors.primary1;

export const getBackgroundColorWithOpacity = (
  opacity: number,
  color: string = defaultBaseColor,
) => `rgba(${convertColor.hex.rgb(color).toString()},${opacity})`;

/**
 * Route row fill. Matches Hive Table row states:
 * selected → surface.canvas.on.selected, hover → surface.canvas.on.hover.
 */
export default (highlighted: boolean, selected: boolean): string | undefined => {
  if (selected) {
    return colorVars.surface.canvas.on.selected;
  }

  if (highlighted) {
    return colorVars.surface.canvas.on.hover;
  }

  return undefined;
};
